var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.to)?_c('router-link',{staticClass:"button",class:{
      dark: _vm.dark,
      big: _vm.big,
      outline: _vm.outline,
      'super-dark': _vm.superDark
    },attrs:{"to":_vm.to}},[(_vm.arrowLeft)?_c('icon',{staticClass:"arrow arrow-line-left",attrs:{"name":"arrow-line-right"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("default")],2),_vm._v(" "),(_vm.arrow)?_c('icon',{staticClass:"arrow arrow-line-right",attrs:{"name":"arrow-line-right"}}):_vm._e()],1):_c('a',{staticClass:"button",class:{
      dark: _vm.dark,
      big: _vm.big,
      outline: _vm.outline,
      'super-dark': _vm.superDark
    },attrs:{"href":_vm.href}},[(_vm.arrowLeft)?_c('icon',{staticClass:"arrow arrow-line-left",attrs:{"name":"arrow-line-right"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("default")],2),_vm._v(" "),(_vm.arrow)?_c('icon',{staticClass:"arrow arrow-line-right",attrs:{"name":"arrow-line-right"}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2358f4e9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vButton.vue
// module id = yd4y
// module chunks = 0